var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispensingOptIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DISPENSING") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DISPENSING",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dispensing-Icon",
    transform: "translate(3.000000, -5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(14.167964, 13.676025) rotate(45.000000) translate(-14.167964, -13.676025) translate(5.552579, 5.028966)",
    fill: "#569177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.978695, 1.002332)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18178092,14.8726999 C-0.393926974,13.2912018 -0.393926974,10.7249247 1.18178092,9.14342655 L9.10994297,1.18612416 C10.6856509,-0.39537622 13.2425107,-0.39537397 14.8182186,1.18612641 C16.3939271,2.76762679 16.3939271,5.33388816 14.8182186,6.91538854 L6.89005652,14.8726999 C5.31434863,16.4541981 2.75748882,16.4541981 1.18178092,14.8726999 Z M6.09724099,5.48307132 L10.5370116,9.93917209 L14.183967,6.27880111 C15.4192664,5.03896086 15.4192639,3.06255409 14.183965,1.82271159 C12.9486656,0.582866843 10.9794957,0.582869094 9.7441941,1.82271159 L6.09724099,5.48307132 Z M11.9244412,6.56725549 C11.7857339,6.39366836 11.8039783,6.11443271 11.9640828,5.96050964 L12.5983341,5.32392446 C12.9509327,4.97002971 13.1668063,4.59828492 13.2226762,4.28947551 C13.2785462,3.9806661 13.2256586,3.72551033 12.9154621,3.41417117 C12.7455537,3.24838259 12.743383,2.94123193 12.9109324,2.77305315 C13.0784929,2.60488112 13.3845253,2.60705076 13.5497,2.77757698 C14.0301011,3.25974396 14.2073647,3.8810066 14.1046752,4.44861112 C14.0019809,5.01622013 13.6705735,5.52089377 13.2326326,5.96053665 L12.5983767,6.59711733 C12.4223488,6.78156168 12.0836376,6.76656999 11.9244861,6.567278 L11.9244412,6.56725549 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Hand_1710632",
    transform: "translate(1.228880, 23.475749)",
    stroke: "#569177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.049988, 0.185294)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(15.578796, 7.544228) rotate(7.000000) translate(-15.578796, -7.544228) translate(3.141549, 1.692835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.032840797,4.69104641 L5.46886577,0.596653051 C5.92038342,0.256571651 6.73979853,0.0468213484 7.2952358,0.127603451 L13.5110561,1.0316246 C14.1783402,1.12867356 14.6210807,1.75456188 14.4993383,2.43296429 L14.4967457,2.44741157 C14.3752748,3.12430115 13.7275142,3.70323696 13.05393,3.74028098 L8.08716531,4.01343027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6295086,2.51573692 L22.868404,0.0678200933 C23.4636846,-0.109047952 24.1068083,0.228608658 24.306247,0.826149585 L24.2938102,0.788887549 C24.4926284,1.38456941 24.2270718,2.13256157 23.6957703,2.46262045 L12.9169529,9.15871416 C12.4355789,9.45775675 11.594139,9.75657286 11.0355092,9.82639298 L0.88777507,11.0947034"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.138702735,3.70484452 L0.138702735,11.6684408 C0.138702735,11.9445832 0.36256036,12.1684408 0.638702735,12.1684408 L2.89202573,12.1684408 C3.1681681,12.1684408 3.39202573,11.9445832 3.39202573,11.6684408 L3.39202573,3.70484452 C3.39202573,3.42870215 3.1681681,3.20484452 2.89202573,3.20484452 L0.638702735,3.20484452 C0.36256036,3.20484452 0.138702735,3.42870215 0.138702735,3.70484452 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispensingOptIn);
export default __webpack_public_path__ + "static/media/dispensing_opt_in.316539313b4783051ff9a0c9adafd1b2.svg";
export { ForwardRef as ReactComponent };